import React from 'react';
import './App.css';
import CPC3000 from './CPC3000';

function App() {
  return (
    <div className="App">
      <CPC3000 />
    </div>
  );
}

export default App;